import cache from 'services/CacheService';

class AbstractDataSource {
  constructor ({dashboardParams}) {
    this.dashboardParams = dashboardParams;
  }

  get cacheKey () {
    throw new Error('Not implemented');
  }

  makeRequest () {
    throw new Error('Not implemented');
  }

  /**
   * Fetch data by params
   * Groups similar requests and caches responses
   * @param widgetData
   *      For OrdersDataSource:
   *          {dsOrdersParams} = payload
   *      For StatisticsDataSource:
   *          {dsStatisticsParams} = payload
   * @param filtration {Object} - dashboard specific filtration (account and projects)
   * @param withVat {Boolean} - request data with VAT
   * @param ignoreCache {Boolean} - ignore cached value and make new request
   * @returns {*}
   */
  fetch (widgetData, filtration, withVat, ignoreCache) {
    return cache.asyncTryCacheOrCall({
      func: this.makeRequest.bind(this),
      funcArgs: {...this.dashboardParams, ...widgetData, ...filtration, withVat},
      onProjectLevel: true,
      key: this.cacheKey
    }, ignoreCache);
  }
}

export default AbstractDataSource;
